import isElement from "lodash.iselement";

function updateTargetWith(base, selector, todo) {
  if (isElement(selector)) {
    todo(selector);
    return;
  }
  if (!isElement(base)) return;
  const target = base.querySelector(selector);
  if (isElement(target)) {
    todo(target);
    return;
  }
}
function updateTextContent(base, selector, value) {
  updateTargetWith(base, selector, target => (target.textContent = value));
}
function updateAttrs(base, selector, attrs) {
  updateTargetWith(base, selector, target =>
    Object.keys(attrs).forEach(key => target.setAttribute(key, attrs[key]))
  );
}
function updateDataset(base, selector, dataset) {
  updateTargetWith(base, selector, target =>
    Object.keys(dataset).forEach(key => (target.dataset[key] = dataset[key]))
  );
}
function updateValue(base, selector, value) {
  updateTargetWith(base, selector, target => (target.value = value));
}
function mapActiveClass(elements = [], className = "", test = () => false) {
  [...elements].forEach(element => {
    if (!isElement(element)) return;
    if (test(element)) {
      element.classList.add(className);
    } else {
      element.classList.remove(className);
    }
  });
}
function dom(selector, attrs, children) {
  const [tagName, ...classNames] = selector.split(".");
  const element = document.createElement(tagName);
  classNames.forEach(cn => element.classList.add(cn));
  Object.keys(attrs).forEach(key => element.setAttribute(key, attrs[key]))
  if (typeof children === "string") element.textContent = children;
  if (Array.isArray(children)) {
    children.forEach(child => {
      if (isElement(child)) {
        element.appendChild(child)
      }
    });
  }
  return element;
}

export {
  updateTextContent,
  updateAttrs,
  updateDataset,
  updateValue,
  mapActiveClass,
  dom,
};



// WEBPACK FOOTER //
// ./src/js/helpers/dom.js